import type {
    CreateMyWishlistMutationVariables,
    DeleteMyWishlistMutationVariables,
    EccoGetMyActiveWishlistQueryVariables,
    GetMasterProductsQueryVariables,
    ProductQueryResult,
    EccoGetMyActiveWishlistQuery,
    GetMasterProductsQuery,
} from "@graphql/generated/types";

import { EccoGetMyActiveWishlistDocument, GetMasterProductsDocument } from "@graphql/generated/sdk";

import { useLocale } from "next-intl";
import { updateQuery, updateMutation } from "../../helpers";
import { useStore } from "../../store";
import { useCommerceClient } from "@graphql/useCommerceClient";

export const useCreateMyWishlist = () => {
    const { client } = useCommerceClient();
    const executeWithVariables = client.createMyWishlist;
    const setData = useStore((state) => state.setWishlist);
    return updateMutation<CreateMyWishlistMutationVariables>(executeWithVariables, setData);
};

export const useDeleteMyWishlist = () => {
    const { client } = useCommerceClient();
    const execute = client.deleteMyWishlist;
    const setData = useStore((state) => state.setWishlist);
    return updateMutation<DeleteMyWishlistMutationVariables>(execute, setData);
};

export const useGetMyActiveShoppingLists = () => {
    const { baseClient } = useCommerceClient();
    const locale = useLocale();
    const setData = useStore((state) => state.setWishlist);

    const selector = (data: any) => {
        return data.me.shoppingLists.results;
    };

    return updateQuery<EccoGetMyActiveWishlistQueryVariables, EccoGetMyActiveWishlistQuery>(
        baseClient,
        setData,
        selector,
        EccoGetMyActiveWishlistDocument,
        {
            locale: locale,
        }
    );
};

export const useGetMyActiveShoppingList = () => {
    const { baseClient } = useCommerceClient();
    const locale = useLocale();
    const setData = useStore((state) => state.setWishlist);

    const selector = (data: any) => {
        return data.me.shoppingLists.results[0];
    };

    return updateQuery<EccoGetMyActiveWishlistQueryVariables, EccoGetMyActiveWishlistQuery>(
        baseClient,
        setData,
        selector,
        EccoGetMyActiveWishlistDocument,
        {
            locale: locale,
        }
    );
};

export const useGetMasterDataForShoppingListLineItems = () => {
    const { baseClient } = useCommerceClient();
    const setData = useStore((state) => state.setWishlistMasterProducts);

    const selector = (data: { products: ProductQueryResult }) => {
        const map = new Map();
        data.products?.results?.forEach((item) => {
            if (!map.has(item.id)) map.set(item.id, item.masterData.current);
        });

        return map;
    };

    const filter = {
        skus: "$skus",
        channelIds: process.env.NEXT_PUBLIC_CHANNEL_ID,
    };

    return updateQuery<GetMasterProductsQueryVariables, GetMasterProductsQuery>(
        baseClient,
        setData,
        selector,
        GetMasterProductsDocument,
        filter
    );
};
